export const COMPLAINT_MAX_FETCH_SIZE = 10000;

export const sortActiveFirst = (list = []) =>
  [...list].sort(
    (a, b) => Number(Boolean(b.isActive)) - Number(Boolean(a.isActive))
  );

export const paginateClientList = (
  list = [],
  currentPage = 1,
  pageSize = 10
) => {
  const start = (Math.max(1, currentPage) - 1) * pageSize;
  return list.slice(start, start + pageSize);
};

export const buildClientPagination = (totalCount, currentPage, pageSize) => ({
  currentPage,
  pageSize,
  totalCount,
});

export const buildActiveFirstPagedResult = ({
  list = [],
  currentPage = 1,
  pageSize = 10,
}) => {
  const sorted = sortActiveFirst(list);
  const totalCount = sorted.length;
  const pagedRecords = paginateClientList(sorted, currentPage, pageSize);

  return {
    allRecords: sorted,
    pagedRecords,
    pagination: buildClientPagination(totalCount, currentPage, pageSize),
  };
};
